import React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { FOREFLIGHT_BLUE } from './styledComponents';

const StyledButton = styled(Button)({
    backgroundColor: FOREFLIGHT_BLUE,
    color: 'white',
    height: '35px',
    marginTop: '20px',
    textTransform: 'none',
    borderRadius: '2px',

    '&:hover': {
        backgroundColor: '#2a3f55',
    },
    '&.Mui-disabled': {
        backgroundColor: '#193e5d !important',
        color: 'rgba(255, 255, 255, 0.5)',
    },
    '& .MuiCircularProgress-root': {
        color: 'white', // <-- spinner color
    },
});

interface Props {
    onSubmit: (e: React.FormEvent) => void;
    children: React.ReactNode;
    isLoading: boolean;
    isDisabled: boolean;
    buttonText?: string;
}
const FormHandler = ({ onSubmit, children, isLoading, isDisabled, buttonText = 'Next' }: Props) => {
    return (
        <form onSubmit={onSubmit}>
            {children}
            <StyledButton
                loading={isLoading}
                fullWidth
                variant="contained"
                type="submit"
                disabled={isDisabled}
            >
                {!isLoading && buttonText}
            </StyledButton>
        </form>
    );
};
export default FormHandler;
